<template>
  <div>
    <To :to="data.to" @updateTo="data.to = $event"></To>
    <FormInput label="Question" :value="data.question" hint="" @update="data.question = $event"></FormInput>
    <Options :options="data.options" @updateOptions="data.options = $event"></Options>
    <h6>Settings</h6>
    <CheckBox label="Anonymous Voting" :value="data.is_anonymous" @change="data.is_anonymous = $event"></CheckBox>
    <CheckBox label="Multiple Answers" :value="data.allows_multiple_answers" @change="data.allows_multiple_answers = $event"></CheckBox> 
    <ReplyMarkup :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup = $event"></ReplyMarkup>
  </div>
</template>


<script>
import ReplyMarkup from '@/components/tasks/fields/ReplyMarkup.vue'
import To from '@/components/tasks/fields/To.vue'
import FormInput from '@/components/tasks/fields/FormInput.vue'
import Options from '@/components/tasks/fields/Options.vue'
import CheckBox from '@/components/tasks/fields/CheckBox.vue'





export default {
  name: 'SendPoll',
  components:{
    ReplyMarkup,
    To,
    FormInput,
    Options,
    CheckBox
  },
  props: {
    data: Object,
    actions: Object
  },
  methods:{
  },


}
</script>
